export var Disposable;

(function (Disposable) {
  function is(arg) {
    return !!arg && typeof arg === 'object' && 'dispose' in arg && typeof arg.dispose === 'function';
  }

  Disposable.is = is;

  function create(func) {
    return {
      dispose: func
    };
  }

  Disposable.create = create;
  Disposable.NONE = create(() => {});
})(Disposable || (Disposable = {}));